<script setup lang="ts">
import { FairButton } from '@/ui/primitives/FairButton'
import type { FairIconName } from '@/ui/tokens/icons.data'

interface FairDialogFooterProps {
  cancelLabel?: string
  confirmLabel?: string
  showCancel?: boolean
  cancelLeadingIcon?: FairIconName
  cancelTrailingIcon?: FairIconName
  confirmLeadingIcon?: FairIconName
  confirmTrailingIcon?: FairIconName
}

withDefaults(defineProps<FairDialogFooterProps>(), {
  cancelLabel: 'Для себя',
  confirmLabel: 'Для себя',
  showCancel: true,
  cancelLeadingIcon: undefined,
  cancelTrailingIcon: undefined,
  confirmLeadingIcon: undefined,
  confirmTrailingIcon: undefined,
})

const emit = defineEmits<{
  cancel: [event: MouseEvent]
  confirm: [event: MouseEvent]
}>()
</script>

<template>
  <footer class="fair-dialog-footer">
    <slot>
      <FairButton
        v-if="showCancel"
        class="fair-dialog-footer__button"
        variant="flat"
        size="l"
        :label="cancelLabel"
        :leading-icon="cancelLeadingIcon"
        :trailing-icon="cancelTrailingIcon"
        @click="emit('cancel', $event)"
      />
      <FairButton
        class="fair-dialog-footer__button"
        variant="primary"
        size="l"
        :label="confirmLabel"
        :leading-icon="confirmLeadingIcon"
        :trailing-icon="confirmTrailingIcon"
        @click="emit('confirm', $event)"
      />
    </slot>
  </footer>
</template>
